import React from 'react'

export default React.createContext({
  clientData: {},
  updateClientData: (e) => {},
})
